module.exports = __webpack_public_path__ + "static/media/jongbokSon.5b48240a.png";